// Bell-toggle outcome notifications for ConfirmationToastBridge — the same
// window-event hop as the like/follow cards (thunks run outside React). Lives
// in utils because both followedArtistsThunk and likesThunk emit it, and
// followedArtistsThunk already imports likesThunk (a thunk-to-thunk import
// here would be circular).
export const NOTIFY_TOAST_EVENT = 'mg:notify-toast';

export function emitNotifyToast(detail) {
    if (typeof window === 'undefined') return;
    try { window.dispatchEvent(new CustomEvent(NOTIFY_TOAST_EVENT, { detail })); } catch { /* non-DOM env */ }
}
